import { ReactElement } from "react";
import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { ChevronsUpDown, X } from "lucide-react";
import { classNames } from "../../UI/Utils/classNames.ts";

export function FilterPopoverField({
  summary,
  isEmpty,
  clearLabel,
  onClear,
  panelWidthClassName = "w-72",
  children,
}: {
  summary: string;
  isEmpty: boolean;
  clearLabel?: string;
  onClear?: () => void;
  panelWidthClassName?: string;
  children: (close: () => void) => ReactElement;
}) {
  return (
    <Popover className="relative">
      <PopoverButton
        className={classNames(
          "relative flex h-10 w-full items-center rounded-lg border border-gray-300 bg-white py-2.5 pl-2.5 text-left text-sm text-gray-800 hover:border-gray-400 data-[open]:border-blue-500",
          onClear ? "pr-16" : "pr-9",
        )}
      >
        <span
          className={classNames(
            "truncate",
            isEmpty ? "text-gray-400" : undefined,
          )}
          title={isEmpty ? undefined : summary}
        >
          {summary}
        </span>
        <ChevronsUpDown
          className="absolute right-3 w-4 text-gray-400"
          aria-hidden
        />
      </PopoverButton>
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          title={clearLabel}
          aria-label={clearLabel}
          className="absolute right-9 top-1/2 -translate-y-1/2 rounded-full p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
      <PopoverPanel
        transition
        anchor="bottom start"
        className={classNames(
          "z-50 max-w-[calc(100vw-2rem)] rounded-lg bg-white p-3 text-left shadow-lg ring-1 ring-black/5 [--anchor-gap:6px] transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0",
          panelWidthClassName,
        )}
      >
        {({ close }) => children(close)}
      </PopoverPanel>
    </Popover>
  );
}
